
import { Component, OnInit, ErrorHandler } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ErroNotificacaoService } from 'src/app/erro-notificacao.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/seguranca/auth.service';
import { SecretariaService } from 'src/app/secretaria/secretaria.service';


@Component({
  selector: 'app-form-secretaria',
  templateUrl: './form-secretaria.component.html',
  styleUrls: ['./form-secretaria.component.css']
})
export class FormSecretariaComponent implements OnInit {

  token: any
  payLoad: any
  foto = ""
  socio: any
  idSocio = 0


  renovarLoginDialog = false;
  aguardeDialog = true;  

  


  constructor(
    private jwtHelper: JwtHelperService,
    private secretariaService: SecretariaService,
    private erro: ErroNotificacaoService,
    private auth: AuthService,
    private rotaNavegar: Router,
    private toasty: ToastrService,
    private rota: ActivatedRoute,
    private error: ErrorHandler
    ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.payLoad = this.jwtHelper.decodeToken(this.token);
    window.scrollTo(0,0);
    this.buscarFotoSocio()
    this.idSocio = this.rota.snapshot.params.id;
    this.buscarDadosSociosPorId()
   }

  buscarFotoSocio() {    
    if(this.payLoad != null) {
      this.secretariaService.buscarFotoSocio(this.payLoad.id, this.token).subscribe(      
        (dados: any) => {
          if(dados) {
            this.foto = `data:image/png;base64,${dados.avatar[0].foto}`;
          } else {
            this.foto = '../../../assets/img/semfoto.jpg';
          }
        }, erro => {
          if(erro.error.error === 'invalid_token') {
            this.toasty.warning('TOKEN DE ACESSO INVÁLIDO!','ATENÇÃO!');
          } else {
            this.erro.handle(erro);
          }        
        });
    }    
  }

  buscarDadosSociosPorId() {
    if(!this.auth.isAccessTokenInvalido()) {
      this.secretariaService.buscarDadosSocioPorId(this.idSocio, this.token).subscribe(
        (dados: any) => {
          this.socio = dados;
          console.log(dados)
        },
        erro => {
          this.error.handleError(erro);
        }
      )

    }else {
      this.renovarLoginDialog = true
    }
  }  
}
